/**
 * Converts a number to string with thousands seperators.
 * @param {Number} n
 * @returns {string} Number with seperators
 */
export const numberWithSeperator = n => {
  if (typeof n === 'string' || typeof n === 'number') {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return ''
  }
}
